import apiService from "../../services/apiService";
const USER_ADDRESS_API = process.env.REACT_APP_BACKEND_API;

export const getUserAddresses = async () => {
  const res = await apiService.get(`${USER_ADDRESS_API}backend/user-addresses`);
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.data?.data)) return res.data.data;

  return [];
};

export const getUserAddressById = async () => {
  const { data } = await apiService.getById(`${USER_ADDRESS_API}backend/user-addresses`);
  return data?.data;
};

export const addUserAddress = async (body) => {
  const { data } = await apiService.create(`${USER_ADDRESS_API}backend/user-addresses`, body);
  return data?.data;
};

export const updateUserAddress = async ({ id, payload }) => {
  const { data } = await apiService.update(`${USER_ADDRESS_API}backend/user-addresses`, id, payload);
  return data?.data;
};

export const removeUserAddress = async (id) => {
  const { data } = await apiService.remove(
    `${USER_ADDRESS_API}backend/user-addresses`, 
    id
  );
  return data?.data;
};

export const getStatesByCountry = async (countryId) => {
  const res = await apiService.get(`${USER_ADDRESS_API}backend/states/${countryId}`);
  if (Array.isArray(res.data?.states)) return res?.data?.states;
  return [];
};
